
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSMode as ObiSModeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-s-mode.js';
 
 
 

 
 export const ObiSMode = createComponent({
   react: React,
   tagName: 'obi-s-mode',
   elementClass: ObiSModeElement,
   events: {
     
   }
  });
 
 